import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuppliersBasketOverviewComponent } from './suppliers-basket-overview/suppliers-basket-overview.component';
import { TranslateModule } from '@ngx-translate/core';
import { IimCardModule, IimDatepickerModule, IimDecimalInputV2Component } from '@iim-angular/components';
import { TextModuleSelectionComponent } from '@lib/shared/text-module';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { AccountingSelectionModule } from '@lib/accounting';
import { SharedImageUiModule } from '@lib/shared/image/ui';
import { DisplayCurrencyModule, StringPreviewModule, SupplierDisplayNamePipe } from '@lib/util';
import { ReactiveFormsModule } from '@angular/forms';
import { ClassificationSelectionComponent } from '@lib/classification';
import { CopyToClipboardModule } from '@lib/core';
import { BasketCurrencyTotalsComponent } from './basket-currency-totals/basket-currency-totals.component';
import { SupplierBasketFeatureModule } from '@lib/basket/suppliers-basket/basket-supplier/feature';

@NgModule({
    imports: [
        SupplierDisplayNamePipe,
        CommonModule,
        TranslateModule,
        IimCardModule,
        TextModuleSelectionComponent,
        MatChipsModule,
        MatSelectModule,
        IimDecimalInputV2Component,
        AccountingSelectionModule,
        SharedImageUiModule,
        StringPreviewModule,
        ReactiveFormsModule,
        IimDatepickerModule,
        ClassificationSelectionComponent,
        CopyToClipboardModule,
        SupplierBasketFeatureModule,
        DisplayCurrencyModule,
        BasketCurrencyTotalsComponent,
    ],
    declarations: [SuppliersBasketOverviewComponent],
    exports: [SuppliersBasketOverviewComponent],
})
export class SuppliersBasketUiModule {}
